import { render } from "./ManageCarCustomFields.vue?vue&type=template&id=379a406e"
import script from "./ManageCarCustomFields.vue?vue&type=script&lang=js"
export * from "./ManageCarCustomFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__